import { createSlice } from '@reduxjs/toolkit';
import {
  loadDepartment,
  saveDepartment,
  updateDepartment,
  removeDepartment,
} from './department-async-thunk';


const initialState = {
  savingStatus: 'idle',
  loadingStatus: 'idle',
  department: {},
  countOfDepartments: 0,
  errors: null,
};

const departmentSlice = createSlice({
  name: 'department',
  initialState,
  reducers: {
    setDepartmentSavingStatus(state, action) {
      const { status } = action.payload;
      state.savingStatus = status;
    },
    setDepartmentLoadingStatus(state, action) {
      const { status } = action.payload;
      state.loadingStatus = status;
    },
    setDepartmentRemovingStatus(state, action) {
      const { status } = action.payload;
      state.removingStatus = status;
    },
  },
  extraReducers: {
    // saveDepartment extra reducer
    [saveDepartment.pending]: (state, action) => {
      state.savingStatus = 'loading';
    },
    [saveDepartment.rejected]: (state, action) => {
      state.savingStatus = 'failed';
      state.errors = action.error.message;
    },
    [saveDepartment.fulfilled]: (state, action) => {
      state.savingStatus = 'successed';
      state.department = action.payload.data;
    },

    // updateDepartmen extra reducer
    [updateDepartment.pending]: (state, action) => {
      state.savingStatus = 'loading';
    },
    [updateDepartment.rejected]: (state, action) => {
      state.savingStatus = 'failed';
      state.errors = action.error.message;
    },
    [updateDepartment.fulfilled]: (state, action) => {
      state.savingStatus = 'successed';
      state.department = action.payload.data;
    },

    // loadDepartment extra reducer
    [loadDepartment.pending]: (state, action) => {
      state.loadingStatus = 'loading';
    },
    [loadDepartment.rejected]: (state, action) => {
      state.loadingStatus = 'failed';
      state.errors = action.error.message;
    },
    [loadDepartment.fulfilled]: (state, action) => {
      state.loadingStatus = 'successed';
      state.department = action.payload.data;
    },

    //removeDepartment extra reducer
    [removeDepartment.pending]: (state, action) => {
      state.removingStatus = 'loading';
    },
    [removeDepartment.rejected]: (state, action) => {
      state.removingStatus = 'failed';
      state.errors = action.error.message;
    },
    [removeDepartment.fulfilled]: (state, action) => {
      state.removingStatus = 'successed';
      state.department = action.payload.data;
    },
  },
});

export const { setDepartmentSavingStatus, setDepartmentLoadingStatus, setDepartmentRemovingStatus } = departmentSlice.actions;

export default departmentSlice.reducer;

export const getDepartmentSavingStatus = (state) => state.department.savingStatus;

export const getDepartmentLoadingStatus = (state) => state.department.loadingStatus;

export const getDepartmentRemovingStatus = (state) => state.department.removingStatus;

export const getDepartment = (state) => state.department.department;
